import { render, staticRenderFns } from "./verificarCodigoRegistro.vue?vue&type=template&id=25d9d262&scoped=true&"
import script from "./verificarCodigoRegistro.vue?vue&type=script&lang=js&"
export * from "./verificarCodigoRegistro.vue?vue&type=script&lang=js&"
import style0 from "./verificarCodigoRegistro.vue?vue&type=style&index=0&id=25d9d262&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d9d262",
  null
  
)

export default component.exports